import { useTranslation } from 'react-i18next';

import { StyledActionsWrap } from '../../components/FilterTableActions/FilterTableActionsStyles';
import { EditIcon, TrashIcon } from '@/icons';
import { StyledActionButton } from '@/components';

import { IBlogCategory } from '@/models/blogCategories.model';

import { COLORS } from '@/theme';

type TBlogCategoriesTableActions = {
  record: IBlogCategory;
  onEdit: (row: IBlogCategory) => void;
  onDelete: (row: IBlogCategory) => void;
};

const BlogCategoriesTableActions = ({ record, onEdit, onDelete }: TBlogCategoriesTableActions) => {
  const { t } = useTranslation(['categories']);

  return (
    <StyledActionsWrap>
      <StyledActionButton
        onClick={() => onEdit(record)}
        $color={COLORS.PALE_YELLOW}
        title={t('blog_category_action_edit')}
      >
        <EditIcon />
      </StyledActionButton>
      <StyledActionButton onClick={() => onDelete(record)} $color={COLORS.RED} title={t('blog_category_action_delete')}>
        <TrashIcon />
      </StyledActionButton>
    </StyledActionsWrap>
  );
};

export default BlogCategoriesTableActions;
